import { render, staticRenderFns } from "./vue-qz-tray-form-nested.vue?vue&type=template&id=bec8b700&scoped=true&"
import script from "./vue-qz-tray-form-nested.vue?vue&type=script&lang=js&"
export * from "./vue-qz-tray-form-nested.vue?vue&type=script&lang=js&"
import style0 from "./vue-qz-tray-form-nested.vue?vue&type=style&index=0&id=bec8b700&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec8b700",
  null
  
)

export default component.exports